import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { MdEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  getPendingOrders,
  getPendingOrdersForupdate,
  RESETORDER,
  selectOrderSuccessUpdate,
  selectPendingOrdersForupdate,
} from "../../redux/features/order/OrderSlice";
import { getItems, selectitems } from "../../redux/features/item/ItemSlice";
import {
  filterItems,
  selectFilteredItems,
} from "../../redux/features/filter/FilterSlice";
import Counter from "../../component/Order/Counter";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { updateOrder } from "../../redux/features/order/OrderSlice";
import { AdminCashier } from "../../component/Protect/HiddenLink";

const UpdateOrder = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState(null);
  const dispatch = useDispatch();
  const pendingOrders = useSelector(selectPendingOrdersForupdate);
  const fliterItems = useSelector(selectFilteredItems);
  const isSuccess = useSelector(selectOrderSuccessUpdate);
  const items = useSelector(selectitems);

  useEffect(() => {
    if (pendingOrders) {
      const foundOrder = pendingOrders.find((order) => order._id === id);
      if (foundOrder) {
        setOrder(foundOrder);
      }
    }
  }, [pendingOrders, id]);
  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const handleAddProduct = (product) => {
    setOrder((prevOrder) => {
      const existingProductIndex = prevOrder.products.findIndex(
        (p) => p.productId === product._id
      );
      let updatedProducts = [...prevOrder.products];

      if (existingProductIndex !== -1) {
        updatedProducts[existingProductIndex] = {
          ...updatedProducts[existingProductIndex],
          quantity: updatedProducts[existingProductIndex].quantity + 1,
        };
      } else {
        updatedProducts.push({
          productId: product._id,
          name: product.name,
          quantity: 1,
          price: product.price,
          description: product.description,
          itemType: product.itemType,
          ingredients: product.ingredients || [],
          dealItems: product?.dealItems || [],
        });
      }

      return {
        ...prevOrder,
        products: updatedProducts,
      };
    });
    setSearch("");
  };

  const handleRemoveProduct = (productId) => {
    setOrder((prevOrder) => {
      const updatedProducts = prevOrder.products.filter(
        (product) => product.productId !== productId
      );
      return {
        ...prevOrder,
        products: updatedProducts,
      };
    });
  };

  const handleQuantityChange = (index, newQuantity) => {
    setOrder((prevOrder) => {
      const updatedProducts = prevOrder.products.map((product, i) =>
        i === index ? { ...product, quantity: newQuantity } : product
      );

      return {
        ...prevOrder,
        products: updatedProducts,
      };
    });
  };

  const serviceCharges = process.env.REACT_APP_SERVICE_CHARGES;

  const totalAmount = order?.products?.reduce(
    (total, product) => total + Number(product.price * product.quantity),
    0
  );

  const handleUpdateOrder = async (order) => {
    if (order.products.length > 0) {
      const updateOrderData = {
        id: order._id,
        products: order.products,
        totalAmount,
        serviceCharges:
          order.tableNo === "parcel"
            ? 0
            : serviceCharges > 0
            ? (Number(totalAmount) / 100) * serviceCharges
            : 0,
      };
      await dispatch(updateOrder(updateOrderData));
    } else {
      toast.error("Order should have minimun one item");
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(getPendingOrders());
      dispatch(RESETORDER);
      setIsOpen(false);
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    dispatch(getItems());
    dispatch(getPendingOrdersForupdate());
  }, [dispatch]);

  useEffect(() => {
    dispatch(filterItems({ search, items }));
  }, [dispatch, search, items]);

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        title="Edit Order"
        className="capitalize lg:px-3 px-2 rounded-xl font-bold text-white py-2 bg-blue-500"
      >
        <MdEdit className="lg:size-6 size-[1.1rem]" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="bg-white lg:w-[60%] md:w-[75%] w-[90%] p-6 pt-0 rounded-xl shadow-xl max-h-[80vh] overflow-y-auto scrollbar-hide shadow-[white]/50 md:mx-0 mx-3 relative">
            <div className="sticky top-0 pb-2 pt-4 bg-white">
              <div className="flex justify-between items-center">
                <div className=" capitalize font-bold text-[1.2rem]">
                  order #{order.orderNo}
                </div>
                <button onClick={() => setIsOpen(!isOpen)}>
                  <FiX className="size-6 transform scale-125" />
                </button>
              </div>

              <div className="my-3 flex justify-between items-end gap-3">
                <div className=" flex-1 flex-grow flex flex-col items-start relative">
                  <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                    min={0}
                    step={1}
                    onWheel={(e) => e.target.blur()}
                    placeholder="Search Item by name"
                    className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                  />

                  {search && (
                    <div className=" absolute bg-white w-full mt-12 rounded-lg flex flex-col text-[#0D868C] shadow max-h-[12rem] h-min overflow-y-auto scrollbar-hide">
                      {fliterItems?.map((item) => (
                        <div
                          key={item._id}
                          className="flex flex-col p-2 border-b last:border-none hover:bg-[#A9A9A9]/10 cursor-pointer"
                          onClick={() => handleAddProduct(item)}
                        >
                          <div className="flex justify-between gap-2 text-[12px] flex-wrap">
                            <p className=" capitalize font-bold">{item.name}</p>
                            <p className=" capitalize font-bold">
                              {priceSymbol}: {item.price}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div>
                  <button
                    onClick={() => handleUpdateOrder(order)}
                    className=" w-max bg-[#0D868C]  cursor-pointer  text-white py-2 px-4 capitalize rounded-md"
                  >
                    Update Order
                  </button>
                </div>
              </div>
            </div>

            {/* Order details */}
            <div className=" pb-4 px-4 mx-auto  rounded-xl flex flex-col gap-3  ">
              <p className="text-[#1E1E1E] text-[1rem] font-bold text-center capitalize">
                Invoice #{order.orderNo}
              </p>
              <div className="flex justify-between items-center border-y border-[#0D868C] lg:p-4 p-3">
                <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal capitalize">
                  Table No: {order.tableNo}
                </p>
              </div>

              <div>
                <div
                  className={`flex items-center w-full p-1 border-b border-[#0D868C]`}
                >
                  <div className="flex flex-col flex-1 gap-1">
                    <h2 className="text-black text-[.7rem]   tracking-[.1em] font-extralight">
                      Item
                    </h2>
                  </div>
                  <div className="flex items-center justify-start w-[60%] text-black text-[.9rem]  ">
                    <p className="w-[30%] text-center ">Qty</p>
                    <p className="w-[25%] text-center">Rate</p>

                    <p className="w-[25%] text-center">Total</p>
                                          <AdminCashier>


                    <p className="w-[20%] text-center">Del</p>
                                          </AdminCashier>
                  </div>
                </div>
                {order.products?.map((item, index) => (
                  <div
                    key={item.productId}
                    className={`flex items-center w-full gap-1 py-2 ${
                      index !== 0 ? "border-t border-[#DEDEDE]" : ""
                    }`}
                  >
                    <div className="flex flex-col flex-1 gap-1">
                      <h2 className="text-[#0D868C] text-[.8rem] lg:text-[1rem] font-semibold capitalize">
                        {item.name}{" "}
                      </h2>

                      {item?.name?.includes("deal") && (
                        <h2 className="text-[#0D868C] text-[.7rem] capitalize">
                          {item?.description}{" "}
                        </h2>
                      )}
                    </div>
                    <div className="flex items-center justify-start w-[60%] text-[#A9A9A9] text-[.8rem] lg:text-[1rem]">
                      <p className="w-[30%]">
                        <div className="mx-auto w-max">
                          <Counter
                            deduction ={false}
                            quantity={item.quantity}
                            onQuantityChange={(newQuantity) =>
                              handleQuantityChange(index, newQuantity)
                            }
                          />
                        </div>
                        {/* X{item.quantity} */}
                      </p>
                      <p className="w-[25%] text-center">{item.price}</p>
                      <p className="w-[25%] text-center">
                        {item.price * item.quantity}
                      </p>
                      <AdminCashier>
                      <FiX
                        onClick={() => handleRemoveProduct(item.productId)}
                        className="text-[#5c5c5c] w-[20%] cursor-pointer text-center"
                      />
                      </AdminCashier>
                    </div>
                  </div>
                ))}
              </div>

              <div>
                <p className="flex flex-col justify-between items-center lg:p-4 p-3 lg:text-[1rem] text-[.8rem] border-y-2 border-[#DEDEDE]">
                  <div className="flex justify-between items-center w-full">
                    <span className="text-[#0D868C] font-bold">Total</span>
                    <span className="text-[#868585]">
                      {priceSymbol}{" "}
                      {order?.products?.reduce(
                        (total, product) =>
                          total + Number(product.price * product.quantity),
                        0
                      )}
                    </span>
                  </div>
                </p>
              </div>

              {/* Lower Section */}
              <div className="flex justify-between items-center text-[#A9A9A9] lg:text-[12px] text-[10px] lg:px-4 px-3 py-2">
                <p>{dayjs(order.createdAt).format("D /M /YYYY . h:mm A")}</p>
                <p>#{order.orderNo}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateOrder;
